import { CONTEXT } from "@const/redux";
import { withdrawFailure, withdrawSuccess } from "./actions";
import { withdrawActionTypes } from "./actionTypes";
import { call, getContext, put, takeEvery } from "redux-saga/effects";
import { getProfile } from "../profile/actions";

const withdrawAsync = ({ PaymentsService, body }) => {
  if (!PaymentsService) {
    console.log("Required services does not exist");
    return;
  }

  return PaymentsService.withdraw(body);
};

function* withdraw({ payload }) {
  try {
    const { PaymentsService } = yield getContext(CONTEXT.SERVICES);
    yield call(withdrawAsync, {
      PaymentsService,
      body: payload,
    });
    yield put(getProfile());
    yield put(withdrawSuccess());
  } catch ({ error }) {
    yield put(withdrawFailure(error));
  }
}

export function* watchWithdraw() {
  yield takeEvery(withdrawActionTypes.request, withdraw);
}
